module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-114x114-df33465e61dd1c0e1e8a017fd9e59741.png";